module.exports = __webpack_public_path__ + "static/img/渠道-3.9e6b3780.png";